/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_Area_Of_StudyInputs */

const en_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area of Study`)
};

const de_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studienrichtung`)
};

const fr_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine d'etudes`)
};

const es_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area de estudio`)
};

const it_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area di studio`)
};

const nl_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiegebied`)
};

const pl_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kierunek studiow`)
};

const fi_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiskeluala`)
};

const da_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fagomrade`)
};

const sv_resume_editor_area_of_study = /** @type {(inputs: Resume_Editor_Area_Of_StudyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studieomrade`)
};

/**
* | output |
* | --- |
* | "Area of Study" |
*
* @param {Resume_Editor_Area_Of_StudyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_area_of_study = /** @type {((inputs?: Resume_Editor_Area_Of_StudyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_Area_Of_StudyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_area_of_study(inputs)
	if (locale === "fr") return fr_resume_editor_area_of_study(inputs)
	if (locale === "es") return es_resume_editor_area_of_study(inputs)
	if (locale === "it") return it_resume_editor_area_of_study(inputs)
	if (locale === "nl") return nl_resume_editor_area_of_study(inputs)
	if (locale === "pl") return pl_resume_editor_area_of_study(inputs)
	if (locale === "fi") return fi_resume_editor_area_of_study(inputs)
	if (locale === "da") return da_resume_editor_area_of_study(inputs)
	if (locale === "sv") return sv_resume_editor_area_of_study(inputs)
	return en_resume_editor_area_of_study(inputs)
});